<template>
  <div>
    <v-select
      v-model="displayYear"
      :items="years"
      item-text="year"
      item-value="year"
      prepend-inner-icon="mdi-calendar"
      :label="label"
      :filled="filled"
      height="43"
      color="primary"
      outlined
      hide-details="false"
      dense
      rounded
      :clearable="clearable"
      :rules="rules"
      elevation="2"
      @change="updateYear"
    />
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'YearPicker',

    model: {
      prop: 'value',
      event: 'input',
    },

    props: {
      value: {
        type: String,
        default: null,
      },
      fullscreen: {
        type: Boolean,
        default: false,
      },
      persistent: {
        type: Boolean,
        default: true,
      },
      label: {
        type: String,
        default: 'Ano',
      },
      filled: {
        type: Boolean,
        default: false,
      },
      rules: {
        type: Array,
        default: () => [],
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      clearable: {
        type: Boolean,
        default: true,
      },
      minYear: {
        type: String,
        default: '2000',
      },
      maxYear: {
        type: String,
        default: '2100',
      },
    },

    data: () => ({
      yearDialog: false,
      year: null,
      displayYear: null,
    }),

    computed: {
      years () {
        const startYear = parseInt(this.minYear, 10)
        const endYear = parseInt(this.maxYear, 10)
        return Array.from({ length: endYear - startYear + 1 }, (_, i) => ({
          year: startYear + i,
        }))
      },
    },

    watch: {
      value: {
        immediate: true,
        handler (val) {
          if (val) {
            const y = moment(val, 'YYYY-MM-DD').year()
            this.year = `${y}-01-01`
            this.displayYear = y
          } else {
            this.year = null
            this.displayYear = null
          }
        },
      },
    },

    methods: {
      closeDialog () {
        this.yearDialog = false
        if (this.year) {
          const y = moment(this.year, 'YYYY').year()
          this.displayYear = y
          this.$emit('input', `${y}-01-01`)
        }
      },
      updateYear (year) {
        this.year = `${year}-01-01`
        this.$emit('input', this.year)
        this.$emit('set', this.year)
      },
    },
  }
</script>
